<div class="title">
  <mat-label>{{ nombreProd }}</mat-label>
  <app-print-button
    class="align-right-print"
    *ngIf="printData && printData.length > 0"
    [data]="printData"
  >
  </app-print-button>
  <i class="fa fa-file-pdf-o"></i>
</div>

<mat-tab-group
  class="sub-tab"
  [selectedIndex]="tab.selectedIndex"
  (selectedIndexChange)="setTabIndex($event, 0)"
>
  <mat-tab #tabResumen>
    <ng-template mat-tab-label>
      <span class="mat-tab-sublabel">RESUMEN</span>
    </ng-template>
    <div id="container-resumen">
      <app-tab-resumen
        [idPoliza]="idPoliza"
        (getPrintData$)="getPrintData($event)"
        [tabActive]="tabResumen.isActive"
        (getResumen$)="onGetResumen($event)"
        [tipo]="tipo"
        [numPersona]="numPersona"
      ></app-tab-resumen>
      <app-card-contratante-vitalicia
        class="margin-bottom"
        [idPoliza]="idPoliza"
        [lineaNegocio]="'RRVV'"
        [tipoSeguro]="tipo"
        [numPersona]="numPersona"
      ></app-card-contratante-vitalicia>
      <app-card-asegurado-vitalicia
        class="margin-bottom"
        [idPoliza]="idPoliza"
        [numPersona]="numPersona"
        [lineaNegocio]="'RRVV'"
        [tipoSeguro]="tipo"
      ></app-card-asegurado-vitalicia>
      <app-card-beneficiarios
        [idPoliza]="idPoliza"
        [tipo]="tipo"
      ></app-card-beneficiarios>
    </div>
  </mat-tab>
  <mat-tab #tabLiquidaciones>
    <ng-template mat-tab-label>
      <span class="mat-tab-sublabel">LIQUIDACIONES</span>
    </ng-template>
    <ng-template matTabContent>
      <app-tab-liquidaciones
        [idPoliza]="idPoliza"
        [lineaNegocio]="'RRVV'"
        [tipoSeguro]="tipo"
        [numPersona]="numPersona"
        (getPrintData$)="getPrintData($event)"
        [tabActive]="tabLiquidaciones.isActive"
      ></app-tab-liquidaciones>
    </ng-template>
  </mat-tab>
  <mat-tab #tabTutoriaLegal>
    <ng-template mat-tab-label>
      <span class="mat-tab-sublabel">TUTORÍA LEGAL</span>
    </ng-template>
    <div class="container-tutoria">
      <app-tutor-legal
        [idPoliza]="idPoliza"
        [lineaNegocio]="'RRVV'"
        [tipoSeguro]="tipo"
        [numPersona]="numPersona"
        (getPrintData$)="getPrintData($event)"
        [tabActive]="tabTutoriaLegal.isActive"
      ></app-tutor-legal>
    </div>
  </mat-tab>
  <mat-tab #tabRescates *ngIf="showRescate">
    <ng-template mat-tab-label
      ><span class="mat-tab-sublabel">RESCATES</span>
    </ng-template>
    <ng-template matTabContent>
      <app-rescates
        [idPoliza]="idPoliza"
        [lineaNegocio]="'RRVV'"
        [tabActive]="tabRescates.isActive"
      >
      </app-rescates>
    </ng-template>
  </mat-tab>
</mat-tab-group>
